const BASE_URL = "/api/contracte";

export const contractApi = {
  // POST: Creare contract
  create: async (dateContract, user) => {
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "user-role": user.rol,
        "user-ocol": user.ocol,
      },
      body: JSON.stringify(dateContract),
    });
    if (!res.ok) {
      const errorData = await res.json();
      throw new Error(errorData.error || "Eroare la crearea contractului");
    }
    return res.json();
  },

  // DELETE: Ștergere contract
  delete: async (id) => {
    const res = await fetch(`${BASE_URL}/${id}`, { method: "DELETE" });
    if (!res.ok) throw new Error("Eroare la ștergerea contractului");
    return res.json();
  },
  edit: async (id, dateNoi) => {
    const res = await fetch(`${BASE_URL}/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dateNoi),
    });

    if (!res.ok) {
      const errorData = await res.json();
      throw new Error(errorData.error || "Eroare la actualizarea contractului");
    }
    return res.json();
  },
};
